<template>
  <div>
    <v-layout justify-space-between>
      <v-flex class="mt-2">
        <h3>キャラルーティン管理</h3>
      </v-flex>

      <v-btn flat small color="grey darken-2" @click="dialog.help=true" onclick="ga('send','event','top','click','help', 1);">
        <v-icon class="mr-1">help_outline</v-icon>使い方
      </v-btn>
    </v-layout>

    <!-- キャラクター表示のカルーセル -->
    <template v-if="!mode.list">
      <v-layout text-xs-center>
        <v-flex xs12>
          <v-carousel class="mt-4" height="423" :cycle="false" hide-controls light delimiter-icon="grade">
            <template v-if="charCount === 0">
              <v-carousel-item>
                <v-layout>
                  <v-flex xs12>
                    <v-card height="372" @click="dialog.addChar=true" onclick="ga('send','event','card','click','create', 1);">
                      <h3 class="pt-4">キャラクター追加</h3>
                      <v-icon color="success" x-large class="mt-5">add_circle</v-icon>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-carousel-item>
            </template>
            <template v-else>
              <v-carousel-item v-for="(item, index) in characters" :key="item.name">
                <CharacterCard :character="item" :index="index"></CharacterCard>
              </v-carousel-item>
            </template>
          </v-carousel>
        </v-flex>
      </v-layout>
    </template>
    <template v-else>
      <v-layout text-xs-center class="mb-5">
        <v-flex xs12 class="mt-3 mb-5">
          <v-card class="mb-5">
            <template v-for="(item, index) in characters">
              <CharacterList :character="item" :index="index" :key="item.name"></CharacterList>
              <div v-if="index+1 != characters.length" :key="index">
                <v-divider></v-divider>
              </div>
            </template>
          </v-card>
        </v-flex>
      </v-layout>
    </template>

    <!-- フローティングアクションボタン -->
    <v-speed-dial v-model="fab" fixed bottom right>
      <template v-slot:activator>
        <v-btn v-model="fab" color="secondary" dark fab large>
          <v-icon>expand_less</v-icon>
          <v-icon>close</v-icon>
        </v-btn>
      </template>
      <v-btn fab dark color="green" @click="dialog.addChar=true">
        <v-icon>person_add</v-icon>
      </v-btn>
      <v-btn fab dark color="red darken-1" @click="dialog.editChar=true">
        <v-icon>edit</v-icon>
      </v-btn>
      <v-btn fab dark color="blue darken-2" @click="modeChange()">
        <v-icon>cached</v-icon>
      </v-btn>
      <!-- <v-btn fab dark small color="brown darken-1">
        <v-icon>settings</v-icon>
      </v-btn> -->
    </v-speed-dial>

    <HelpDialog :dialog="dialog"></HelpDialog>

    <!-- キャラクター編集ダイアログ -->
    <v-dialog v-model="dialog.editChar" lazy max-width="700">
      <v-card class="xs12 sm12 md12 lg6 xl6">
        <v-card-title>
          <h3>キャラクター編集</h3>
        </v-card-title>
        <v-divider></v-divider>

       <v-list two-line>
          <template v-if="charCount === 0">
            <v-card-title>
              キャラクターが存在しません
            </v-card-title>
          </template>
          <template v-else>
            <template  v-for="(item, index) in characters">
              <CharacterInfo :character="item"
                            :index="index"
                            :key="item.name"
                            :snackbar="snackbar"
                            :deleteChar="deleteChar"></CharacterInfo>

              <div v-if="index+1 != characters.length" :key="index">
                <v-divider inset></v-divider>
              </div>
            </template>
          </template>
        </v-list>
      </v-card>
    </v-dialog>

    <!-- キャラクター追加ダイアログ -->
    <v-dialog v-model="dialog.addChar" persistent lazy max-width="700">
      <v-card>
        <v-card-title>
          <h3>キャラクター追加</h3>
        </v-card-title>
        <v-divider></v-divider>

        <v-layout row justify-center class="mt-4">
          <v-flex xs10>

            <v-avatar class="mb-2" :size="60">
              <v-img :src="jobIcon" alt="avatar"></v-img>
            </v-avatar>

            <v-select
              required
              label="職業"
              item-value="value"
              item-text="label"
              v-model="create.job"
              return-object
              color="secondary"
              :items="jobs"></v-select>

            <v-text-field
              required
              label="名前"
              color="secondary"
              v-model="create.name"></v-text-field>

            <v-text-field
              readpnly
              label="レベル"
              v-model="create.level"
              color="secondary"
              type="number"></v-text-field>

            <v-slider
              v-model="create.level"
              class="mt-0"
              color="secondary"
              :min="0"
              :max="200"></v-slider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click="cancelCreateCharacter()" color="secondary">キャンセル</v-btn>
              <v-btn flat @click="createCharacter()" color="secondary">追加</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteChar.isDialog" max-width="600">
      <v-card>
        <v-card-title>
          <h3>キャラクター削除</h3>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-title>
          <div class="mt-3">{{deleteChar.name}} を削除してもよろしいでしょうか？</div>
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="deleteChar.isDialog=false" color="primary">キャンセル</v-btn>
          <v-btn flat @click="deleteCharacter()" color="primary">削除</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.isShow"
                multi-line
                top right
                :color="snackbar.color"
                :timeout="5000">
      {{snackbar.text}}
      <v-btn icon @click="snackbar.isShow = false">
        <v-icon color="grey lighten-5">clear
        </v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  import CharacterCard from '../components/CharacterCard'
  import CharacterInfo from '../components/CharacterInfo'
  import CharacterList from '../components/CharacterList'
  import HelpDialog from '../components/HelpDialog'

  import dayjs from 'dayjs'

  export default {
    title: 'キャラルーティン管理',
    components: {
      CharacterCard,
      CharacterInfo,
      CharacterList,
      HelpDialog
    },
    data: () => ({
      mode: {
        list: false,
      },
      dialog: {
        addChar: false,
        editChar: false,
        help: false,
      },
      characters: [],
      create: {
        name: '',
        level: 10,
        job: {
          label: '',
          value: 'no'
        },
        fight: 0,
        check: {
          pet: false,
          equip: false,
          fight: false,
          neto: false,
          dojo: false,
          event: false,
        },
      },
      jobs: require('../data/jobs.js'),
      jobIcon: require('../assets/job/no.png'),
      snackbar: {
        isShow: false,
        color: '',
        text: '',
      },
      deleteChar: {
        name: '',
        index: 0,
        isDelete: false,
        isDialog: false,
      },
      fab: false,
    }),
    computed: {
      charCount: function () {
        return this.characters.length;
      },
    },
    watch: {
      'create.job': function (val) {
        this.jobIcon = require(`../assets/job/${this.create.job.value}.png`)
      },
    },
    methods: {
      createCharacter: function () {
        this.characters.push(JSON.parse(JSON.stringify(this.create)));
        localStorage.setItem('characters', JSON.stringify(this.characters));

        this.snackbar.text = `キャラクター ${this.create.name} を追加しました`;

        this.create.name = null;
        this.create.job = {
          label: null,
          value: 'no'
        };
        this.create.level = 10;
        this.dialog.addChar = false;

        this.snackbar.color = 'success';
        this.snackbar.isShow = true;
      },
      cancelCreateCharacter: function () {
        this.create.name = null;
        this.create.job = {
          label: null,
          value: 'no'
        };
        this.create.level = 10;
        this.dialog.addChar=false;
      },
      deleteCharacter: function () {
        const local = JSON.parse(localStorage.getItem('characters'));
        local.splice(this.deleteChar.index, 1);
        localStorage.setItem('characters', JSON.stringify(local));

        this.characters = JSON.parse(JSON.stringify(local));
        this.snackbar.text = `キャラクター ${this.deleteChar.name} を削除しました`;

        this.deleteChar = {
          name: '',
          index: 0,
          isDelete: false,
          isDialog: false,
        };

        this.dialog.editChar = false;
        this.snackbar.color = 'success';
        this.snackbar.isShow = true;
      },
      modeChange: function () {
        this.mode.list =  !this.mode.list;
        localStorage.setItem('mode', this.mode.list);
      },
    },
    created: function () {
      // キャラクターデータの取得
      const local = localStorage.getItem('characters');
      this.characters = local === null ? [] : JSON.parse(local);

      // 最終アクセスの日付比較（チェックリストのリセット）
      const activeDate = localStorage.getItem('activeDate');
      if ( activeDate !== null && dayjs().isAfter(dayjs(activeDate), 'days')) {
        this.characters.forEach(val => {
          val.check = {
            pet: false,
            equip: false,
            fight: false,
            neto: false,
            dojo: false,
            event: false,
          };
        });
        localStorage.setItem('characters', JSON.stringify(this.characters));

        this.snackbar.text = 'チェックリストをリセットしました';
        this.snackbar.color = 'blue darken-1';
        this.snackbar.isShow = true;
      }
      localStorage.setItem('activeDate', dayjs().format('YYYY/MM/DD'))

      // 表示モードの取得
      const mode = localStorage.getItem('mode');
      this.mode.list = mode === 'true';
    }
  }
</script>

<style scoped>
  #create .v-speed-dial {
    position: absolute;
  }
  #create .v-btn--floating {
    position: relative;
  }
  .v-speed-dial--bottom:not(.v-speed-dial--absolute) {
    bottom: 75px;
  }
</style>
